import PropTypes from 'prop-types';
import BorderBox from '../components/BorderBox';

const GeneralInfo = (props) => (
    <div className="max-on-big content padding-page-normal center">
        <BorderBox>{props.info}</BorderBox>
    </div>
);

GeneralInfo.propTypes = {
    info: PropTypes.string.isRequired,
};

export default GeneralInfo;
